import React, { useEffect, useState} from "react";
import Header from "../components/Header";
import Product4 from "../components/Product4";
import { BsChevronRight, BsExclamationLg, BsSearch } from "react-icons/bs";
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import {alert, confirm} from "../components/MegConfirmAlert";
import { useForm} from "react-hook-form";
import { useAxios } from "../services/useAxios";
import { Link , useLocation ,useParams } from "react-router-dom";
import { useDaumPostcodePopup } from 'react-daum-postcode';

export default function ReturnRequest() {
    const { t } = useTranslation();
    const {register, handleSubmit, formState , setFocus, watch, setValue, clearErrors }= useForm();
    const{errors} = formState;
    const [modalShow, setModalShow] = React.useState(false);
    const [request] = useAxios();
    const [checkItems, setCheckItems] = useState([]);
    const open = useDaumPostcodePopup();
    let {id} = useParams();
    const [data, setData] = useState({});
    const [isAgr, setAgr] = useState(false);

    const phoneRegex = /^01([0|1|6|7|8|9]?)-?([0-9]{3,4})-?([0-9]{4})$/
    function regPhoneNumber(e) {
        const result = e.target.value
          .replace(/[^0-9.]/g, "")
          .replace(/^(\d{0,3})(\d{0,4})(\d{0,4})$/g, "$1-$2-$3")
          .replace(/(-{1,2})$/g, "");

        setValue('returnCllctPntCttpc', result, { shouldValidate: true })          
    }

    const fetchData = async () => {
       
        const response = await request.post("/app/mypage/getMyOrderReturnTargetInfoAPI", {
            orderNo: id
        });

        if(response.data.resultCode === 200){
            console.log(response.data)
            if((response.data.result.orderDelivInfo.orderProcessSttusCode !=='ODR005' )){                    
                window.location.href="/OrderHistory";
            }else{
                console.log(response.data.result)
                setData(response.data.result);   

            }       
        }
    };

    const handleSingleCheck = (checked, id) => {
        if (checked) {
          // 단일 선택 시 체크된 아이템을 배열에 추가
          setCheckItems(prev => [...prev, id]);
        } else {
          // 단일 선택 해제 시 체크된 아이템을 제외한 배열 (필터)
          setCheckItems(checkItems.filter((el) => el !== id));
        }
      };

      const handleAllCheck = (checked) => {
        if(checked) {
          // 전체 선택 클릭 시 데이터의 모든 아이템(id)를 담은 배열로 checkItems 상태 업데이트
          const idArray = [];
          data.orderDelivDetailList.forEach((el) => idArray.push(el.orderDetailSn));
          setCheckItems(idArray);
        }
        else {
          // 전체 선택 해제 시 checkItems 를 빈 배열로 상태 업데이트
          setCheckItems([]);
        }
      }

      const onSubmit = async formData=> {

        if(checkItems.length === 0 ){
            alert(t(`Message.my_order_return_required_goods`))
            return
        }
        
        if(!isAgr){
            alert("반품 안내사항에 대하여 동의하여 주십시오.")
            return
        }

        

        const response = await request.post("/app/mypage/procMyOrderReturnReqAPI", {
            orderNo: id,
            userId : data.orderDelivInfo.userId,
            orderSn : data.orderDelivInfo.orderSn,
            orderDetailList :checkItems,
            returnResnCode : formData.returnResnCode,
            returnResnDetail :formData.returnResnDetail,                        
            returnCllctPntCttpc : formData.returnCllctPntCttpc,
            returnDlvyTyCode : formData.returnDlvyTyCode,
            returnCllctPayMethodCode : formData.returnResnCode!=='RSN002'?'':formData.returnCllctPayMethodCode,
            returnCllctPntZip : formData.returnDlvyTyCode!=='RTN001'?'':formData.returnCllctPntZip,
            returnCllctPntBassAdres : formData.returnDlvyTyCode!=='RTN001'?'':formData.returnCllctPntBassAdres,
            returnCllctPntDetailAdres : formData.returnDlvyTyCode!=='RTN001'?'':formData.returnCllctPntDetailAdres
        });
        
        if(response.data.resultCode === 200){     
            await alert(response.data.resultMessage);        
            window.location.href="/OrderHistory";      
        }else{
            alert(response.data.resultMessage);
        }

        console.log(formData)
      }

      const handleComplete = (data) => {
        let addr = '';
        let extraAddr = '';
        
        //사용자가 선택한 주소 타입에 따라 해당 주소 값을 가져온다.
        if (data.userSelectedType === 'R') { // 사용자가 도로명 주소를 선택했을 경우
            addr = data.roadAddress;
        } else { // 사용자가 지번 주소를 선택했을 경우(J)
            addr = data.jibunAddress;
        }

        // 사용자가 선택한 주소가 도로명 타입일때 참고항목을 조합한다.
        if(data.userSelectedType === 'R'){
            // 법정동명이 있을 경우 추가한다. (법정리는 제외)
            // 법정동의 경우 마지막 문자가 "동/로/가"로 끝난다.
            if(data.bname !== '' && /[동|로|가]$/g.test(data.bname)){
                extraAddr += data.bname;
            }
            // 건물명이 있고, 공동주택일 경우 추가한다.
            if(data.buildingName !== '' && data.apartment === 'Y'){
                extraAddr += (extraAddr !== '' ? ', ' + data.buildingName : data.buildingName);
            }
            // 표시할 참고항목이 있을 경우, 괄호까지 추가한 최종 문자열을 만든다.
            if(extraAddr !== ''){
                extraAddr = ' (' + extraAddr + ')';
            }
            // 조합된 참고항목을 해당 필드에 넣는다.
            setValue("returnCllctPntDetailAdres", extraAddr);
        
        } else {
            setValue("returnCllctPntDetailAdres", '');            
        }

        // 우편번호와 주소 정보를 해당 필드에 넣는다.
        setValue("returnCllctPntZip", data.zonecode);
        setValue("returnCllctPntBassAdres",addr);
        clearErrors('returnCllctPntZip')
        clearErrors('returnCllctPntBassAdres')
      };

    useEffect(() => {
        fetchData();
      }, []);
     

    return (
        <div>
            {data.orderDelivInfo && (data.orderDelivInfo.orderProcessSttusCode ==='ODR005' )?(
            <>
            <div className="backGround bgBlue"></div>
            <Header type="cart" pageTitle={t(`Message.my_order_hist_list_return_req`)}/>

            <div className="returnWr">
                <div className="returnProd">
                    <div className="chkWr">
                        <input type="checkbox"  id="aa" onChange={(e) => handleAllCheck(e.target.checked)}
                            checked={checkItems.length === data.orderDelivDetailList.length ? true : false}/>
                        <label htmlFor="aa">{t(`Message.all_check_overall_selection`)}</label>
                    </div>
                    {data.orderDelivDetailList && data.orderDelivDetailList.map((obj, index) => (  
                    <Product4
                        key={index}
                        type="type13"
                        img={"https://www.salee.co.kr/com/cmm/getGoodsImageView.sale?goodsFileTy=i&goodsFileSn="+(obj.goodsImageSn?obj.goodsImageSn:0)}
                        prodName={obj.goodsNm}
                        option1={obj.firstOptnNm}
                        option2={obj.firstOptnValue}
                        disprice={"￦"+(!obj.sleAmount?0:obj.sleAmount).toLocaleString('ko-KR')}
                        qty={obj.orderQy}
                        obj ={obj}  
                        checkItems = {checkItems}
                        handleSingleCheck = {handleSingleCheck} 
                        />
                    ))}                                
                </div>
                <form onSubmit={handleSubmit(onSubmit)} className="dfColG20">    
                <div className="rdoTxtWr">
                    <p className="tit">{t(`Message.my_order_return_reason`)}</p>
                    <ul className="radioList">
                        {data.cmDetailcodeList && data.cmDetailcodeList.map((obj, index) => (  
                        <li key={index}>
                            <input type="radio" id={obj.code} value={obj.code} {...register("returnResnCode",{ required:"필수 응답 항목입니다."})}  />
                            <label  htmlFor={obj.code}>{obj.codeNm}</label>
                        </li>
                         ))}         
                         {watch("returnResnCode") === 'RSN999'?(              
                        <li>
                            <textarea name="returnResnDetail" {...register("returnResnDetail")}  placeholder={t(`Message.my_order_return_required_reason`)}></textarea>
                        </li>
                        ):null}   
                        {errors.returnResnCode && <p role="alert" className="alertRed">{errors.returnResnCode.message}</p>}
                    </ul>
                    
                </div>

                <div className="rdoTxtWr">
                    <p className="tit">{t(`Message.my_order_return_collect_at`)}</p>
                    <ul className="radioList">
                        <li>
                            <input type="radio" name="returnDlvyTyCode" id="c1" value="RTN001" {...register("returnDlvyTyCode",{ required:"필수 응답 항목입니다."})} />
                            <label htmlFor="c1">{t(`Message.my_order_return_collection_recall_req`)}</label>
                        </li>
                        <li>
                            <input type="radio" name="returnDlvyTyCode" id="c2" value="RTN003" {...register("returnDlvyTyCode",{ required:"필수 응답 항목입니다."})} />
                            <label htmlFor="c2">{t(`Message.my_order_return_collection_non_recall`)}</label>
                        </li>
                        {errors.returnDlvyTyCode && <p role="alert" className="alertRed">{errors.returnDlvyTyCode.message}</p>}
                    </ul>
                </div>
                {watch("returnResnCode") === 'RSN002'?(        
                <div className="rdoTxtWr">
                    <p className="tit">{t(`Message.my_order_return_pay_method`)}</p>
                    <ul className="radioList">
                        <li>
                            <div className="a">
                                <p className="cFFF">{t(`Message.my_order_return_recovery_cost`)}</p>
                                <p className="cYellow">￦5,000</p>
                            </div>
                        </li>
                        <li>
                            <input type="radio" name="returnCllctPayMethodCode" id="d1" value="MTH001" {...register("returnCllctPayMethodCode",{ required:"필수 응답 항목입니다."})} />
                            <label htmlFor="d1">{t(`Message.my_order_return_pay_method_radio1`)}</label>
                        </li>
                        <li>
                            <input type="radio" name="returnCllctPayMethodCode" id="d2" value="MTH002" {...register("returnCllctPayMethodCode",{ required:"필수 응답 항목입니다."})} />
                            <label htmlFor="d2">{t(`Message.my_order_return_pay_method_radio2`)}</label>
                        </li>
                        <li>
                            <input type="radio" name="returnCllctPayMethodCode" id="d3" value="MTH003" {...register("returnCllctPayMethodCode",{ required:"필수 응답 항목입니다."})} />
                            <label htmlFor="d3">{t(`Message.my_order_return_pay_method_radio3`)}</label>
                        </li>
                        {errors.returnCllctPayMethodCode && <p role="alert" className="alertRed">{errors.returnCllctPayMethodCode.message}</p>}
                    </ul>
                </div>
                 ):null}   

                <div className="">
                    <p className="tit">{t(`Message.dlvy_info_regist_contact`)}</p>
                    <input type="tel" maxLength={13} placeholder={t(`Message.my_order_return_hint_contact`)}  {...register("returnCllctPntCttpc",{ onChange: (e) => {regPhoneNumber(e)}, required: t(`Message.ordrr_form_required_mobile`), pattern: {value: phoneRegex, message: "올바른 휴대폰 형식이 아닙니다."}})}/>
                    {errors.returnCllctPntCttpc && <p role="alert" className="alertRed">{errors.returnCllctPntCttpc.message}</p>}
                </div>

                {watch("returnDlvyTyCode") === 'RTN001'?(        
                <div className="returnAdr">
                    <p className="tit">{t(`Message.my_order_return_collection_adres_title`)}</p>
                    <ul>
                        <li>
                            <button type="button" className="btn40 cFFF greenB mb10" onClick={(e)=>open({ onComplete: handleComplete })}><BsSearch />{t(`Message.my_order_return_collection_adres_search`)}</button>
                        </li>
                        <li>
                            <input type="text" {...register("returnCllctPntZip", { required:t(`필수 응답 항목입니다.`)})}  disabled/>
                            {errors.returnCllctPntZip && <p role="alert" className="alertRed">{errors.returnCllctPntZip.message}</p>}
                        </li>
                        <li>
                            <input type="text" {...register("returnCllctPntBassAdres", { required:t(`필수 응답 항목입니다.`)})}  disabled/>
                            {errors.returnCllctPntBassAdres && <p role="alert" className="alertRed">{errors.returnCllctPntBassAdres.message}</p>}
                        </li>
                        <li>
                            <input type="text" placeholder={t(`Message.dlvy_info_regist_hint_dtl_adres`)}{...register("returnCllctPntDetailAdres", {})} />
                            {errors.returnCllctPntDetailAdres && <p role="alert" className="alertRed">{errors.returnCllctPntDetailAdres.message}</p>}
                        </li>                        
                    </ul>
                </div>
                 ):null}   
                 
                <ul className="termsCheck">
                    <li className="chkWr">
                        <input type="checkbox" name="aaa" id="aaa" onChange={(e)=>{setAgr(e.target.checked)}}/>
                        <label htmlFor="aaa">{t(`Message.my_order_return_info_confirm_at`)}</label>
                    </li>
                    <li className="btnWr">
                        <button type="button" onClick={(e) => setModalShow(true)}><BsChevronRight /></button>
                    </li>
                </ul>

                <div className="rrBtnWr">                    
                    <button type="submit"  className="btn44 orgB cFFF">{t(`Message.my_order_return_apply`)}</button>
                </div>
                </form>
            </div>




            <Modal 
                className="btModal"
                show={modalShow}
                onHide={() => setModalShow(false)}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                >
                <div className="scrollArea">    
                    <div className="returnCaution">
                        <div className="modalIcon"><BsExclamationLg /></div>
                            <h3 className="rcTit">{t(`Message.my_order_return_info_dialog_precautions_title`)}</h3>
                            <p>{t(`Message.my_order_return_info_dialog_precautions_cn1`)}</p>
                            <p>{t(`Message.my_order_return_info_dialog_precautions_cn2`)}</p>
                            <p>{t(`Message.my_order_return_info_dialog_precautions_cn3`)}</p>
                            <p>{t(`Message.my_order_return_info_dialog_precautions_cn4`)}</p>
                            <p>{t(`Message.my_order_return_info_dialog_precautions_cn5`)}</p>

                            <h3 className="rcTit">{t(`Message.my_order_return_info_dialog_possibility_title`)}</h3>
                            <p>{t(`Message.my_order_return_info_dialog_possibility_cn1`)}</p>
                            <p>{t(`Message.my_order_return_info_dialog_possibility_cn2`)}</p>

                            <h3 className="rcTit">{t(`Message.my_order_return_info_dialog_impossibility_title`)}</h3>
                            <p>{t(`Message.my_order_return_info_dialog_impossibility_cn1`)}</p>
                            <p>{t(`Message.my_order_return_info_dialog_impossibility_cn2`)}</p>
                            <p>{t(`Message.my_order_return_info_dialog_impossibility_cn3`)}</p>
                            <p>{t(`Message.my_order_return_info_dialog_impossibility_cn4`)}</p>
                            <p>{t(`Message.my_order_return_info_dialog_impossibility_cn5`)}</p>
                        </div>
                    </div>
                <div className="modalBtnWr">
                    <button onClick={() => setModalShow(false)}>{t(`Message.common_ok`)}</button>
                </div>
            </Modal>
            </>
            ):null}
        </div>
    );
};